module.exports = __webpack_public_path__ + "img/worldmapsouthkoreawithdetail.3f952224.png";